module.exports = __webpack_public_path__ + "media/images/icons/icon-tutoring-90187e065adc3fd190a8d2ed13f9b050.svg";